// extracted by mini-css-extract-plugin
export default {"congrats":"newBadgeCongratulation_congrats__aPb8o","close":"newBadgeCongratulation_close__PMUkN","container":"newBadgeCongratulation_container__U6lDg"};